{
  "eyebrow": "Фактуриране и плащане",
  "title": "Почти готово.",
  "sub": "Продължете към сигурната ни каса, за да започнете 30-дневния пробен период. Днес няма да ви бъде начислена сума.",
  "summary": {
    "company": "Фирма",
    "plan": "План",
    "cycle": "Цикъл на фактуриране",
    "users": "Потребители",
    "vtt": "Vehicle Track & Trace",
    "vehicles": "Превозни средства",
    "total": "Прогнозна сума / месец",
    "vttOn": "Включено"
  },
  "secureNote": "Сигурна каса чрез Stripe · 30 дни пробен период · Отказ по всяко време",
  "continue": "Продължи към Stripe",
  "submitting": "Отваря се Stripe…",
  "canceled": {
    "title": "Плащането е отказано",
    "sub": "Не е извършено плащане. Опитайте отново или се свържете с нас при нужда.",
    "retry": "Опитай отново"
  },
  "promo": {
    "toggle": "Имате промокод?",
    "placeholder": "Промокод",
    "apply": "Приложи",
    "chip": "{{percent}}% отстъпка",
    "remove": "Премахни промокода",
    "errorGeneric": "Кодът не можа да бъде проверен. Опитайте отново."
  },
  "errors": {
    "generic": "Плащането не можа да бъде стартирано. Опитайте отново."
  },
  "totalUnavailable": "Каталогът с цени е недостъпен. Опитайте отново, за да заредите най-новите цени."
}
